import pkceChallenge from "pkce-challenge";

interface AuthRedirect {
  url: string;
  codeVerifier: string;
}

export const authUrl = async (): Promise<AuthRedirect> => {
  try {
    const AZURE_TENANT_ID = process.env.REACT_APP_AZURE_TENANT_ID;
    const AZURE_APP_ID = process.env.REACT_APP_AZURE_APP_ID;
    const REDIRECT_URI = process.env.REACT_APP_AZURE_REDIRECT_URI;

    const { code_verifier, code_challenge } = await pkceChallenge();

    return {
      codeVerifier: code_verifier,
      url: `https://login.microsoftonline.com/${AZURE_TENANT_ID}/oauth2/v2.0/authorize?response_type=code&client_id=${AZURE_APP_ID}&redirect_uri=${REDIRECT_URI}&scope=openid profile email User.Read&state=some_state&code_challenge=${code_challenge}&code_challenge_method=S256`,
    };
  } catch (error) {
    throw new Error("Erro ao gerar URL de autenticação: " + error);
  }
};

export const isTokenValid = (expiresAt: number): boolean => {
  if (!expiresAt) return false;
  return new Date().getTime() < Number(expiresAt);
};
